import React from 'react';
import { useTranslation } from 'react-i18next';
import CalendarIcon from '../../icons/round-calendar.svg';
import { ResultPageLayout } from '../../layouts/ResultPageLayout';
import { ReturnToBookingPortal } from './buttons';
import { CancelledAlreadyProps } from './types';

export const CancelledAlready = ({ restaurantName, date, time, email, linkTo }: CancelledAlreadyProps) => {
	const { t } = useTranslation();

	return (
		<ResultPageLayout headerIcon={CalendarIcon} iconAltText={t('titles.cancellation_confirmed')}>
			<ResultPageLayout.Title>{t('titles.cancellation_confirmed')}</ResultPageLayout.Title>

			<ResultPageLayout.Body>
				<p>
					{t('messages.booking_already_cancelled', {
						restaurantName,
						date,
						time
					})}
				</p>

				<p>
					{t('messages.cancellation_email_received', {
						email
					})}
				</p>

				<ResultPageLayout.Footer>
					<ReturnToBookingPortal to={linkTo} />
				</ResultPageLayout.Footer>
			</ResultPageLayout.Body>
		</ResultPageLayout>
	);
};
